import React, { useState } from 'react'
import { ArticleForm } from '../components/forms'

const AddArticle = () => {
    const [saveAndNotify, setSaveAndNotify] = useState(false)

    return (
        <ArticleForm
            submitButtonProps={{
                label: saveAndNotify ? 'Save and notify' : 'Save',
            }}
            updateSaveAndNotify={setSaveAndNotify}
            allowUploads
        />
    )
}

export default AddArticle
